import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const STATUS_LABELS = {
    non_iniziato: 'Non iniziato',
    in_corso: 'In corso',
    in_verifica: 'In verifica',
    bloccato: 'Bloccato',
    completato: 'Completato',
    annullato: 'Annullato'
};

export const ROLE_LABELS = {
    admin: 'Amministratore',
    back_office: 'Back Office',
    tecnico: 'Tecnico',
    progettista: 'Progettista',
    installatore: 'Installatore',
    responsabile: 'Responsabile Operativo',
    responsabile_store: 'Responsabile Store',
    store_agent: 'Agente Store',
    logistica: 'Logistica',
    amministrazione: 'Amministrazione',
    viewer: 'Viewer'
};

export const CONTRACT_TYPE_LABELS = {
    residenziale: 'Residenziale',
    industriale: 'Industriale',
    commerciale: 'Commerciale',
    agricolo: 'Agricolo'
};

export function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
}

export function formatDateTime(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}

export function formatFileSize(bytes) {
    if (!bytes) return '-';
    const units = ['B', 'KB', 'MB', 'GB'];
    let unitIndex = 0;
    let size = bytes;
    
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
    }
    
    return `${size.toFixed(1)} ${units[unitIndex]}`;
}

export function getStatusColor(status) {
    const colors = {
        non_iniziato: 'bg-muted text-muted-foreground',
        in_corso: 'bg-blue-100 text-blue-800',
        in_verifica: 'bg-amber-100 text-amber-800',
        bloccato: 'bg-red-100 text-red-800',
        completato: 'bg-green-100 text-green-800',
        annullato: 'bg-gray-100 text-gray-800'
    };
    return colors[status] || colors.non_iniziato;
}

export function calculateProgress(nodes) {
    if (!nodes || nodes.length === 0) return 0;
    const completed = nodes.filter(n => n.status === 'completato').length;
    return Math.round((completed / nodes.length) * 100);
}
